module.exports = __webpack_public_path__ + "statics/img/cate8-6@2x.13bf2a81.png";